<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="1000px"
    scrollable
    class="scrollDesign"
  >
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">
          {{
            $t(
              'extracurricular.import_students_modal.import_students_modal_title'
            )
          }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-stepper v-model="e1" class="elevation-0">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" :step="1">
                  {{ $t('extracurricular.import_students_modal.upload_file') }}
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" :step="2">
                  <span v-if="!working.validating">{{ modal.text }}</span>
                  <v-progress-circular
                    v-else
                    size="20"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-stepper-step>
                <v-divider></v-divider>

                <v-stepper-step :step="3">
                  {{ $t('extracurricular.import_students_modal.completed') }}
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :step="1">
                  <v-card height="400px">
                    <v-card-title class="subheading">
                      {{
                        $t(
                          'extracurricular.import_students_modal.import_your_students_excel_file_example'
                        )
                      }}
                      <a
                        href="examples/lista_ejemplo_alumnos_extracurriculares.xlsx"
                      >
                        {{ $t('generic.download') }}
                      </a>
                    </v-card-title>
                    <v-layout row wrap justify-center>
                      <v-flex xs12 class="form-csv text-xs-center">
                        <input
                          @change="imageLoad($event)"
                          id="file_csv_extras"
                          type="file"
                          accept=".xlsx"
                        />
                        <div class="csv-text">
                          <h4 class="center-align">
                            {{
                              $t(
                                'extracurricular.import_students_modal.drag_your_excel_file_here'
                              )
                            }}
                          </h4>
                          <h5 id="csv-success">
                            {{ $t('extracurricular.import_students_modal.or') }}
                            <u style="color: red">
                              <span style="color: red">
                                {{
                                  $t(
                                    'extracurricular.import_students_modal.select'
                                  )
                                }}
                              </span>
                            </u>
                            {{
                              $t(
                                'extracurricular.import_students_modal.the_file'
                              )
                            }}
                          </h5>
                        </div>
                      </v-flex>
                      <v-expand-transition>
                        <v-flex
                          v-show="working.loading"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 200"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="green"
                            >check</v-icon
                          >Archivo válido
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 201"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="orange"
                            >warning</v-icon
                          >Archivo con registros erróneos pero aún importable
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 404"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="red"
                            >clear</v-icon
                          >El archivo no es válido
                        </v-flex>
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-flex
                          v-show="flags.status == 403"
                          mt-3
                          xs12
                          class="text-xs-center"
                        >
                          <v-icon style="vertical-align: bottom" color="red"
                            >clear</v-icon
                          >El formato del archivo no es correcto; descarga el
                          ejemplo para mayor información
                        </v-flex>
                      </v-expand-transition>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content :step="2">
                  <v-card>
                    <v-data-table
                      :headers="headers"
                      :items="errorItems"
                      :loading="working.validating"
                    >
                      <v-progress-linear
                        v-slot:progress
                        color="primary"
                        indeterminate
                      ></v-progress-linear>
                      <template v-slot:headers="props">
                        <tr>
                          <th
                            v-for="header of props.headers"
                            :key="header.text"
                          >
                            {{ $t(header.langKey) }}
                          </th>
                        </tr>
                      </template>
                      <template v-slot:items="props">
                        <td v-if="flags.status != 200">
                          <v-edit-dialog
                            :return-value.sync="props.item.Matricula"
                            lazy
                          >
                            {{ props.item.Matricula }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Matricula"
                                label="Matrícula"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Matricula }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Nivel"
                            lazy
                          >
                            {{ props.item.Nivel }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Nivel"
                                label="Nivel"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Nivel }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Actividad"
                            lazy
                          >
                            {{ props.item.Actividad }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Actividad"
                                label="Actividad"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Actividad }}</td>
                        <td v-if="flags.status != 200" class="text-xs-right">
                          <v-edit-dialog
                            :return-value.sync="props.item.Grupo"
                            lazy
                          >
                            {{ props.item.Grupo }}
                            <template v-slot:input>
                              <v-text-field
                                v-model="props.item.Grupo"
                                label="Grupo"
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </td>
                        <td v-else>{{ props.item.Grupo }}</td>
                        <td
                          v-if="excel2jsonFail.length > 0"
                          class="text-xs-right"
                        >
                          {{ props.item.Error }}
                        </td>
                        <td v-else></td>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content :step="3">
                  <v-card height="400px">
                    <v-layout row wrap justify-center>
                      <v-flex xs12 class="text-xs-center">
                        <h1>{{ modal.title }}</h1>
                        <v-alert
                          style="border-radius: 33px"
                          :value="true"
                          :type="flags.status == 201 ? 'warning' : 'success'"
                          >{{ modal.message }}</v-alert
                        >
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="noButtons && e1 != 3"
          :disabled="e1 == 1"
          color="primary"
          icon
          @click="back"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="noButtons && e1 < 3" flat small @click="close">
          {{ $t('generic.cancel') }}
        </v-btn>
        <v-btn
          v-if="e1 == 3 && flags.status == 201"
          color="primary"
          @click="download"
        >
          {{ $t('generic.cancel') }}
        </v-btn>
        <v-btn v-if="e1 == 3" @click="close" flat>
          {{ $t('extracurricular.import_students_modal.completed') }}
        </v-btn>
        <v-btn
          v-if="e1 == 2 && modal.text == 'Corrección de errores'"
          color="primary"
          small
          @click="next"
        >
          {{ $t('extracurricular.import_students_modal.validate') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="noButtons && e1 != 3"
          :disabled="flags.continue"
          color="primary"
          icon
          @click="e1 == 2 ? importAlways() : next()"
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { funciones } from '../../Mixins/Funciones'
export default {
  props: ['value'],
  mixins: [funciones],
  mounted() {
    this.$store
      .dispatch('tutor/getLevelsExtraTool')
      .then((response) => {
        for (const [
          index,
          item,
        ] of response.data.entity.extracurricular.entries()) {
          this.levels[item.typeLevel.toLowerCase()] = [item.id]
          this.lAbbrs[item.abbr.toLowerCase()] = [item.id]
          var ggs = []
          for (const [index2, gg] of item.ggs.entries()) {
            ggs[gg.grade.toLowerCase() + '' + gg.group.toLowerCase()] = gg.id
          }
          this.levels[item.typeLevel.toLowerCase()][1] = ggs
          this.lAbbrs[item.abbr.toLowerCase()][1] = ggs
        }
      })
      .catch((error) => {
        console.log(error)
      })
  },
  data: () => ({
    e1: 0,
    levels: [],
    lAbbrs: [],
    modal: {
      text: 'Verificación de contenido',
      title: '',
      message: '',
    },
    working: {
      loading: false,
      validating: false,
    },
    flags: {
      continue: true,
      status: 0,
    },
    headers: [
      {
        text: 'Matrícula',
        align: 'left',
        value: 'personId',
        align: 'center',
        sortable: false,
        langKey: 'extracurricular.import_students_modal.student_id',
      },
      {
        text: 'Nivel',
        align: 'center',
        sortable: false,
        value: 'level',
        langKey: 'extracurricular.import_students_modal.grade_level',
      },
      {
        text: 'Actividad',
        value: 'grade',
        align: 'center',
        sortable: false,
        langKey: 'extracurricular.import_students_modal.activity',
      },
      {
        text: 'Grupo',
        value: 'group',
        align: 'center',
        sortable: false,
        langKey: 'extracurricular.import_students_modal.group',
      },
      {
        text: 'Error',
        sortable: false,
        value: 'Error',
        langKey: 'extracurricular.import_students_modal.error',
      },
    ],
    errorItems: [],
    correctItems: [],
    report: [],
    noButtons: true,
  }),
  methods: {
    imageLoad(event) {
      this.working.loading = true
      this.processFile(
        event.target.files,
        event.target.value,
        'alumnos-extras',
        {
          levels: this.levels,
          abbrs: this.lAbbrs,
        }
      )
        .then((result) => {
          this.working.loading = false
          if (result == 200 || result == 201) {
            this.flags.status = result
            this.flags.continue = false
          }
        })
        .catch((err) => {
          this.working.loading = false
          if (this.excel2jsonFail.length < 15 && err != 403) {
            this.flags.status = 201
            this.flags.continue = false
          } else {
            this.flags.status = err
            this.flags.continue = true
          }
        })
    },
    back() {
      switch (this.e1) {
        case 2:
          this.e1 = 1
          this.errorItems = []
          this.$forceUpdate()
          break
      }
    },
    next() {
      switch (this.e1) {
        case 1:
          this.e1 = 2
          if (this.excel2jsonFail.length > 0) {
            this.errorItems = this.excel2jsonFail
            this.modal.text = this.$t(
              'extracurricular.import_students_modal.error_corrections'
            )
          } else {
            this.errorItems = this.excel2json
          }
          this.$forceUpdate()
          break
        case 2:
          this.working.validating = true
          var p = new Promise((resolve, reject) => {
            for (var r in this.errorItems) {
              if (this.errorItems[i].Error != null) {
                this.excel2json.push(this.errorItems[r])
              }
            }
            this.validateExcelStdsExtras(resolve, reject, {
              levels: this.levels,
              abbrs: this.lAbbrs,
            })
          })
            .then((result) => {
              this.working.validating = false
              if (result == 201) {
                this.modal.text = this.$t(
                  'extracurricular.import_students_modal.error_corrections'
                )
                this.errorItems = this.excel2jsonFail
              } else {
                this.modal.text = 'Verificación de contenido'
                this.errorItems = this.excel2json
              }
              this.flags.status = result
              this.$forceUpdate()
            })
            .catch((err) => {
              this.working.validating = false
            })
          break
      }
    },
    import() {
      for (var i in this.errorItems) {
        if (this.errorItems[i].Error != null)
          this.excel2json.push(this.errorItems[i])
      }
      this.noButtons = false
      var flag = 0
      var allStds = []
      for (var c in this.excel2json) {
        var student = {
          level: this.excel2json[c].level,
          gg: this.excel2json[c].gg,
          personId: this.excel2json[c].Matricula,
        }
        // aqui tienes la lista de objetos en Json
        allStds.push(student)
      }
      var json = JSON.stringify(allStds)
      var obj = JSON.parse(json)
      this.$store
        .dispatch('student/importStudentsExtra', obj)
        .then((response) => {
          this.$emit('imported', '')
          this.report = response.data.entity
          this.flags.status = 200
          this.modal.title = 'Importación exitosa'
          this.modal.message = 'La lista fue importada correctamente'
          this.working.validating = false
          this.e1 = 3
          for (let r of this.report) {
            if (r.code != 200) {
              this.flags.status = 201
              this.modal.title = this.$t(
                'extracurricular.import_students_modal.warning'
              )
              this.modal.message = this.$t(
                'extracurricular.import_students_modal.last_step_warn'
              )
            }
          }
          this.noButtons = true
        })
        .catch((error) => {
          if (
            error.data.code == 400 ||
            error.data.code == 1015 ||
            error.data.code == 1009
          ) {
            this.$emit('imported', '')
            this.working.validating = false
            this.e1 = 3
            this.flags.status = 201
            this.modal.title = this.$t(
              'extracurricular.import_students_modal.warning'
            )
            this.modal.message =
              'Hubo un problema al importar la lista, intente de nuevo, por favor.'
            this.$forceUpdate()
          }
          this.noButtons = true
        })
    },
    importAlways() {
      this.working.validating = true
      this.import()
    },
    close() {
      this.$emit('input', false)
      this.$emit('success')
      this.e1 = 1
      this.excel2json = []
      this.noButtons = true
      this.excel2jsonFail = []
      this.badlist = false
      this.errorCode = 0
      this.flags.continue = true
      this.flags.status = 0
      document.getElementById('file_csv_extras').value = ''
    },
    download() {
      var content = []
      console.log(this.report)
      for (const [index, item] of this.report.entries()) {
        var register = {}
        register['Matricula'] = item.entity.personId
        register['Nivel'] = item.entity.level.typeLevel
        register['Actividad'] = item.entity.gg.grade
        register['Grupo'] = item.entity.gg.group
        register['Estado'] = item.message
        content.push(register)
      }

      this.downloadReport(content)
    },
  },
}
</script>
<style>
.form-csv input {
  position: absolute;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 190px;
  outline: none;
  opacity: 0;
}

.csv-text {
  margin-top: 10%;
}

.form-csv {
  height: 200px;
  border: 4px dashed #c6c7c7;
  background-color: #eceff0;
}
</style>

<style scoped>
td,
th {
  width: 190px;
  max-width: 190px;
  min-width: 190px;
}
</style>
